import { gql } from "@apollo/client";

export const GET_LIQUIDACION_FINAL = gql`
query liquidacionFinal($input: PreLiquidacionFiltersInput!){
    liquidacionFinal(input: $input){
        success
        error
        valorEsperado{
            idLiquidacionProfesional
            idLiquidacionProfesionalDetalle
            idProfesional
            profesional
            codigoSAPProfesional
            idEvaluacion
            idEvaluacionProfesional
            paciente
            fechaDesdeEvaluacion
            fechaHastaEvaluacion
            fechaDesdeProfesional
            fechaHastaProfesional
            diasServicio
            diasSuspendido
            totalDias
            cantVisitas
            programa
            planCuidado
            figuraProfesional
            liquidacionTotal
            liquidacionTotalMesAnterior
            observacionRechazo
            observacionDesestimar
            tieneConexion
            montoAjuste
            observacionAjuste
            tieneHonorarioFidelizado
            montoFidelizadoUnitario
            cuenta 
            centroCosto 
            centroAlmacenamiento 
            descripcionServicio 
            numeroOC
        }
    }
}
`;